import { Component, OnInit } from '@angular/core';
import {Localiser} from '../../services/localiser';
import {UserService} from '../../services/user.service';
import {Navigation} from '../../services/navigation.service';
import {ProyectoService} from "../../services/proyecto.service";
import {plano} from "../../models/plano";
import {PlanoService} from "../../services/plano.service";

@Component({
  selector: 'app-warnings',
  templateUrl: './warnings.component.html',
  styleUrls: ['./warnings.component.css']
})
export class WarningsComponent implements OnInit {

  constructor(public localiser: Localiser, public user: UserService, private navigation: Navigation,
              public proyectoService: ProyectoService, public planoService: PlanoService) { }

  ngOnInit(): void {
    if (!this.proyectoService.proyectoActualCookie()) {
      this.proyectoService.setTrueSelectALocation("warnings");
      this.toLocations();
    } else {
      this.proyectoService.setLastPage("warnings")
    }
    this.planoService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe(result => {
      console.log(result)
    });
  }

  toLocations() {
    this.navigation.toLocations();
  }

}
